// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".switchers-container[data-v-301e3c89]{display:flex;flex-direction:column;align-items:center;align-items:flex-start;margin:20px 0}.switch[data-v-301e3c89]:not(:last-child){margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
